export default class paymentProfile {
    /** @ngInject */
    constructor(moment, $q, dates, $http, PaymentsProfileResource, ProductsResource) {

        this.paymentsProfile = PaymentsProfileResource;
        this.productsResource = ProductsResource;

        this.subscribed_products = null;
        this.currentProduct = null;

        this.dependencies = {
            dates: dates,
            moment: moment,
            $q: $q,
            $http: $http,
            PaymentsProfileResource: PaymentsProfileResource,
            ProductsResource: ProductsResource
        };

        this.get();
    }


    get() {

        const promises = {
            profile: this.paymentsProfile.getProfile().$promise,
            plans: this.productsResource.get().$promise
        };

        this.dependencies.$q.all(promises).then((data) => {
            // index plans by Id
            let plans = {};
            data.plans.forEach((item) => {
                plans[item.id] = item;
            });

            //resolve product id to product object
            data.profile.subscribed_products.forEach((item) => {
                item.product_id = item.product;
                item.product = plans[item.product_id];
            });
            return data;
        })
            .then((data) => {
                angular.extend(this, data.profile);
                this.currentProduct = data.profile.subscribed_products.find((product) => {
                    //TODO: Ability to get more info about product group
                    return (product.is_active);
                });
            });
    }

    getCurrentSubscription() {
        return this.currentProduct;
    }

    cancel() {
        this.subscription_end_date = this.getExpirationDate();
    }

    rejoin() {
    }

    getExpirationDate() {
        return this.dependencies.dates.getDateNextMonth(this.subscription_start_date);
    }

    getCardExpirationDate() {
        let now = this.dependencies.moment().endOf('month'),
            cardExpirationDate = this.dependencies.moment(this.card_expiration_date);

        if (cardExpirationDate.isAfter(now)) {
            return cardExpirationDate.format('MM/YY');
        }

        return 'Expired';
    }

    getTransactions() {

    }

}



// WEBPACK FOOTER //
// ./user/services/payment-profile.js